export default function BackgroundImg({ className }) {
  return <div className={className}></div>;
}
